/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as React from 'react';

import { FiltersTypeProps } from '../../../types/filters';
import { toggleFilterGroups, type UiFiltersState } from '../../../utils/filters';
import { CampsiteTypeFilters } from './CampsiteTypeFilters';
import { MustHaveFilters } from './MustHaveFilters';

interface CampingFiltersProps {
    /** Selected filter groups */
    fg: string[];
    uiFilters: UiFiltersState;
    onFilterGroupsChange: (fg: string[]) => void;
    hasDates: boolean;
}

/** Camping type and must-have camping filters */
export function CampingFilters({
    fg,
    uiFilters,
    onFilterGroupsChange,
    hasDates,
}: CampingFiltersProps) {
    const onChange = React.useCallback(
        (_event: React.ChangeEvent<HTMLInputElement>, item: FiltersTypeProps) => {
            onFilterGroupsChange(toggleFilterGroups(item, { fg }));
        },
        [fg, onFilterGroupsChange]
    );

    return (
        <>
            <CampsiteTypeFilters
                fg={fg}
                uiFilters={uiFilters}
                onChange={onChange}
                onFilterGroupsChange={onFilterGroupsChange}
            />
            <MustHaveFilters
                fg={fg}
                onChange={onChange}
                onFilterGroupsChange={onFilterGroupsChange}
                hasDates={hasDates}
            />
        </>
    );
}
